module.exports = __webpack_public_path__ + "img/CRTNJLS.b90989e5.svg";